import { memo } from 'react';
import ProcessSupervisionTaskComponent from './ProcessSupervisionTaskComponent';
import { StepViewComponentProps } from '../stepDescriptor/types';

function ProcessSupervisionPinnedViewComponent(props: StepViewComponentProps) {
  return <ProcessSupervisionTaskComponent {...props} isPinnable isPinnedView />;
}
export default memo(ProcessSupervisionPinnedViewComponent);
